import React, {ReactElement} from "react";
import {SSOProvider} from "../../common/enums/ssoProvider.enum";
import Google from "../../common/icons/providers/google";
import Facebook from "../../common/icons/providers/facebook";

interface SSOButtonProps {
    provider: string,
    destination: string
}

export const SSOButton = ({provider, destination }: SSOButtonProps) => {
    
    let icon: ReactElement = <> </>;
 
    switch (provider) {
        case SSOProvider.Google:
            icon = <Google />;
            break;
        case SSOProvider.Facebook:
            icon = <Facebook />;
            break;
    }

    return (
        <a className="sso-button" href={destination}>
            {icon} <p style={{marginLeft: '8px'}} className="sso-button-text" >Continue with {provider}</p>
        </a>
    );
}